import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import {
  KoobButton,
  KoobInputNumber,
  KoobInputLabel,
  KoobInputSelect,
} from '@koob/ui';
import { useField } from 'formik';
import KoobParagraph from '../../../../components/Koob/KoobParagraph';
import KoobTitle from '../../../../components/Koob/KoobTitle';

export default function BulkEditorUpdateMargin({
  fieldName,
  results,
  filterResult,
  showOnlySelected,
}) {
  const { t } = useTranslation('toConnectionRequest');
  const [{ value: items }, , { setValue: setItems }] = useField(
    `request.${fieldName}`,
  );
  const [marginType, setMarginType] = useState(null);
  const [marginValue, setMarginValue] = useState(null);
  const [visibility, setVisibility] = useState(null);

  const applyToSelected = () => {
    const newItems = items.map((item) => {
      const isVisibleInCurrentResults = results?.some(
        (result) => String(result.id) === String(item.id),
      );

      const matchesCurrentFilter =
        !filterResult || showOnlySelected === true || filterResult(item);

      const isSelected = item.isSelected === true || item.isSelected === 'true';

      if (
        !isSelected ||
        (!isVisibleInCurrentResults && !matchesCurrentFilter)
      ) {
        return item;
      }

      const newItem = { ...item };

      if (marginType !== null) {
        newItem.isMarginPercent = marginType;
      }

      if (marginValue !== null && marginValue !== '') {
        newItem.margin = marginValue;
      }

      if (visibility !== null) {
        newItem.distribute = visibility;
      }

      return newItem;
    });

    setItems(newItems);
  };

  return (
    <div>
      <KoobTitle>{t('bulkEdit.editor.updateSelection')}</KoobTitle>

      <div className="mt-3 grid grid-cols-4 justify-end items-end gap-3">
        <KoobInputSelect
          label={t('bulkEdit.editor.marginType')}
          placeholder={t('bulkEdit.editor.noChange')}
          value={marginType}
          onValueChange={setMarginType}
          options={[
            { label: t('bulkEdit.editor.noChange'), value: '' },
            { label: t('bulkEdit.editor.marginPercent'), value: true },
            { label: t('bulkEdit.editor.marginFixed'), value: false },
          ]}
          disabled={visibility === false || visibility === 'false'}
        />

        <KoobInputLabel label={t('bulkEdit.editor.marginValue')}>
          <KoobInputNumber
            value={marginValue}
            onValueChange={setMarginValue}
            min={0}
            disabled={visibility === false || visibility === 'false'}
          />
        </KoobInputLabel>

        <KoobInputSelect
          label={t('bulkEdit.editor.visibility')}
          placeholder={t('bulkEdit.editor.noChange')}
          value={visibility}
          onValueChange={setVisibility}
          options={[
            { label: t('bulkEdit.editor.noChange'), value: '' },
            { label: t('bulkEdit.editor.visible'), value: true },
            { label: t('bulkEdit.editor.invisible'), value: false },
          ]}
        />

        <KoobButton onClick={() => applyToSelected()} variant="primary">
          {t('bulkEdit.editor.applyToSelected')}
        </KoobButton>
      </div>

      <KoobParagraph size="sm">
        {t('bulkEdit.editor.leaveEmptyForNoChange')}
      </KoobParagraph>
    </div>
  );
}
